import { forwardRef } from 'react';
import { Turnstile } from '@marsidev/react-turnstile'
import PropTypes from 'prop-types';


const TurnstileCaptcha = forwardRef(({ onSuccess, onError }, ref) => {
  return (<div className='flex w-full justify-center'>
    <Turnstile
      ref={ref}
      siteKey={import.meta.env.VITE_TURNSTILE_SITE_KEY}
      onSuccess={onSuccess}
      onError={onError}
    />
  </div>);
});

TurnstileCaptcha.displayName = 'TurnstileCaptcha';

TurnstileCaptcha.propTypes = {
  onSuccess: PropTypes.func.isRequired,
  onError: PropTypes.func.isRequired,
};

export default TurnstileCaptcha;